module.exports = __webpack_public_path__ + "static/media/top@2x.20593328.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SkwizColors/top@2x.png
// module id = ./src/assets/SkwizColors/top@2x.png
// module chunks = 0